<template>
  <div class="header-container">
    <!-- 侧栏折叠 -->
    <div class="header-left">
      <div
        :class="['header-hamburger', {'header-hamburger-fold': foldAside}]"
        @click="handleFoldAside()" :title="foldAside ? '展开' : '收缩'">
        <SvgIcon icon="ant-design:menu-fold-outlined" width="18px" />
      </div>
    </div>
    <!-- 面包屑 -->
    <Breadcrumb class="headerBreadCrumb" />
    <div class="header-right">
      <!-- 打卡 -->
      <ClockIn class="header-clock-in" />
      <!-- 坐席信息 -->
      <div :class="['seat', {'seat-isOnline': isOnline}]" v-if="lusUserCti.roleLevel > 1">
        <span class="seat-number">分机号：{{ lusUserCti.cno || "无" }}</span>
        <strong class="seat-status">{{ ctiStatus }}</strong>
        <span class="seat-number" v-if="lusUserCti.autoDial">是否开启自动拨号：</span>
        <el-switch
          v-if="lusUserCti.autoDial"
          :value="callerWindowState.autoDialStateDesc"
          active-color="#13ce66"
          inactive-color="#ff4949"
          @change="checkoutAutoDialStatus">
        </el-switch>
        <el-dropdown trigger="click" style="margin-left: 10px; cursor:pointer;" @command="handleClick">
          <el-button class="btn-status-primary" :type="'primary'" size="small">坐席状态切换</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="unpause" v-if="ctiStatus !== '在线'">在线</el-dropdown-item>
            <el-dropdown-item command="pause" v-if="isOnline">忙碌</el-dropdown-item>
            <el-dropdown-item command="logOut" v-if="ctiStatus !== '离线'">离线</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 用户信息 -->
      <el-dropdown class="user-info" @command="handleCommand" trigger="click">
        <span class="user-info-entry flex-center">
          <span>{{ userInfo.name.slice(0, 1) }}</span>
          <SvgIcon icon="ep:arrow-down-bold" width="14px" />
        </span>
        <el-dropdown-menu slot="dropdown" class="user-info-pop">
          <div class="user-info-pop-name">{{ userInfo.name }}</div>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Breadcrumb from "@/layout/components/Breadcrumb.vue";
import { Message } from "element-ui";
import ClockIn from './ClockIn.vue';
import {callHelper} from "@/utils/helper/caller.helper";
import { callerWindowState } from "@/utils/helper/caller.window.state";
import { clearLogin } from '@/api/base/request';

export default {
  name: "WisdomCloudHeader",
  components: {
    Breadcrumb,
    ClockIn
  },
  props: {
    lusUserCti: Object,
  },
  data() {
    let userInfo = {name: '', id: ''};
    const userInfoStorage = localStorage.getItem("userInfo");
    if (userInfoStorage) userInfo = JSON.parse(userInfoStorage);

    return {
      userInfo,
      callerWindowState,
    };
  },
  computed: {
    ...mapState('global', ["foldAside", "seatClockStatus"]),
    ctiStatus(){return this.callerWindowState.ctiStatus;},
    isOnline(){return this.ctiStatus === '在线';}
  },
  mounted() {},
  methods: {
    handleFoldAside(){this.$store.commit('global/handleFoldAside');},
    handleClick(e) {
      if (!['success'].includes(this.seatClockStatus)){
        this.$message.warning('请先完成上班签到，再进行此操作');
        return;
      }

      if (['ON_RING', 'ON_CALLING'].includes(this.callerWindowState.callWindowStatus)) {
        this.$message.error("请完成当前通话！");
        return;
      }
      sessionStorage.setItem('__store_ctiStatus', e);
      callHelper[e]()
    },
    handleCommand(command) {
      if (command === "logout") {
        clearLogin();
        if (this.lusUserCti.cno && ['success'].includes(this.seatClockStatus)) callHelper.logOut();
        location.href = `/login?needCode=1&redirectUrl=${window.location.href}`;
        // this.$router.replace({name: "login"});
      }
    },
    // 切换自动拨号
    checkoutAutoDialStatus(flag) {
      const {callWindowStatus} = this.callerWindowState;

      if (!['success'].includes(this.seatClockStatus)){
        this.$message.warning('请先完成上班签到，再进行此操作');
        return;
      }

      if (['ON_RING', 'ON_CALLING'].includes(callWindowStatus)) {
        Message.error("请完成当前通话！");
        return;
      }

      this.callerWindowState.autoDialStateDesc = flag;
      flag === true ? callHelper.startAutoDial() : callHelper.closeAutoDial();
    },
  },
};
</script>
<style lang="scss" scoped src="./index.scss">

</style>
